<template>
  <div class="leave">
    <leaveTopbar
      v-model="currentCourseIndex"
      :statusList="statusList"
      @selectTime="selectTime"
      @selectType="selectType"
      :className="className"
      :classPlaceholder="classPlaceholder"
      :classProps="classProps"
      :classSelect="classSelect"
      @changeHandle="changeHandle"
    />
    <div class="leave-main">
      <leaveContentItem
        v-for="(item, index) in statusList"
        :key="index"
        :isCurrentContentItem="currentCourseIndex == index"
        :currentStatus="statusList[currentCourseIndex].value"
        :startTime="startTime"
        :endTime="endTime"
        :leaveType="leaveType"
        @updateStatus="updateStatus"
        :changeStatus="changeStatus"
        :classData="classData"
      />
    </div>
    <leaveDetail
      v-show="detailShow"
      :detailShow.sync="detailShow"
      :leaveDetail="leaveDetail"
    />
  </div>
</template>

<script>
import leaveTopbar from "./components/leave-topbar/leave-topbar.vue";
import leaveContentItem from "./components/leave-content-item/leave-content-item.vue";
import leaveDetail from "./components/leave-detail/leave-detail.vue";

export default {
  data() {
    return {
      currentCourseIndex: 0,
      startTime: "",
      endTime: "",
      leaveType: "",
      changeStatus: null,
      statusList: [
        {
          label: "审批",
          value: 1,
        },
        {
          label: "审批通过",
          value: 2,
        },
        {
          label: "审批拒绝",
          value: 3,
        },
      ],
      leaveDetail: {},
      detailShow: false,
      // 处理后的班级年级多选数据
      classSelect: [],
      // 级联选择器属性配置
      classProps: {
        expandTrigger: "hover",
        children: "schoolClassList",
      },
      // 选中后的班级年级
      className: [],
      // 班级年级数据
      classSelectList: [],
      classPlaceholder: "全部",
      classData: {
        classId: "",
        className: "",
      },
    };
  },
  components: {
    leaveTopbar,
    leaveContentItem,
    leaveDetail,
  },
  created() {
    this.selectSchoolAndGradeAndClassListPC();
    // 显示请假详情
    this.$eventBus.$off("showDetail");
    this.$eventBus.$on("showDetail", (id) => {
      this.selectLeaveRecordDesc(id);
    });
  },
  methods: {
    changeHandle(e) {
      this.classData.classId = e.length ? e[1].classId : '';
      this.classData.className = e.length ? e[1].className : '全部';
      // this.changeStatus = e.length ? e[1].classId : 999999999999999;
      this.changeStatus = Math.random();
    },
    // 年级和班级选择列表
    selectSchoolAndGradeAndClassListPC() {
      this.get(this.$url.getgradeList, {
        schoolId: this.user.schoolId,
      })
        .then((res) => {
          if (res.code !== 200) {
            return this.$message.error(res.msg);
          }
          // console.log(res);
          this.classSelectList = res.data;
          this.classSelectListLength = this.classSelectList.length;
          // console.log(this.classSelectList.length);
          if (this.classSelectList.length) {
            this.classSelectList.forEach((gItem, g) => {
              let { gradeCode, gradeId, gradeName } = gItem;
              gItem.value = {
                gradeCode,
                gradeId,
                gradeName,
              };
              gItem.label = gItem.gradeName;
              gItem.schoolClassList.forEach((cItem, c) => {
                let { classCode, classId, className } = cItem;
                cItem.value = {
                  classCode,
                  classId,
                  className,
                };
                cItem.label = cItem.className;
              });
            });
            this.classSelect = this.classSelectList;
            // 默认选中时的classId/className
            // this.classData.classId =
            //   this.classSelect[0].schoolClassList[0].classId;
            // this.classData.className =
            //   this.classSelect[0].schoolClassList[0].className;
            // 获取学生列表
            this.changeStatus = this.classSelect[0].schoolClassList[0].classId;

            // 默认选中第一个年级班级
            // let firstGrade = {};
            // let { gradeCode, gradeId, gradeName } = this.classSelect[0];
            // firstGrade = { gradeCode, gradeId, gradeName };
            // let firstClass = {};
            // let { classCode, classId, className } =
            //   this.classSelect[0].schoolClassList[0];
            // firstClass = { classCode, classId, className };
            // this.className = [firstGrade, firstClass];
            // this.classPlaceholder = `${firstGrade.gradeName} / ${firstClass.className}`;
            // console.log("处理后的数据==>", this.classSelect);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$message.error("获取班级列表失败");
        });
    },
    selectTime(e) {
      this.startTime = e.startTime;
      this.endTime = e.endTime;
    },
    selectType(e) {
      this.leaveType = e;
    },
    updateStatus(e) {
      this.changeStatus = e;
    },
    // 获取请假详情
    selectLeaveRecordDesc(id) {
      // console.log('获取请假详情==>',this.$url);
      this.post(this.$url.selectLeaveRecordDesc, {
        id,
      })
        .then((res) => {
          // console.log(res)
          if (res.code == 200) {
            this.leaveDetail = res.data;
            this.detailShow = true;
          } else if (res.code == 1403) {
          } else {
            this.$message.error("获取详情失败");
          }
        })
        .catch((err) => {
          this.$message.error("获取详情失败，请稍后再试");
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./leave.scss";
</style>
